import React, { useState, useEffect } from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_URL, getServerUrl } from '../../services/api';
import ErrorToast from '../Common/ErrorToast';
import Toast from '../Common/Toast';
import {
  Gem, LayoutDashboard, Store, Users, Package,
  Warehouse, UserCircle, ShoppingCart, ArrowLeftRight, LogOut, Tag, History,
  Truck, Wrench, FileText, ShoppingBag, CreditCard, Box, Grid, Settings,
  ChevronLeft, ChevronRight, Menu, Receipt, Lock, ClipboardList, Activity, Database, Printer, Scale, Shield, DollarSign, BarChart3,
  PackageCheck
} from 'lucide-react';

function Layout({ children, workspaceContext, onChangeContext }) {
  const { user: authUser, logout: authLogout, isAdmin } = useAuth();
  const location = useLocation();
  const contextType = workspaceContext?.type || 'central';
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [entreprise, setEntreprise] = useState({ nom: 'BOTUHA', logo: null });

  // Close mobile sidebar on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    fetch(`${API_URL}/parametres/bijouterie`)
      .then(r => r.json()).then(d => {
        if (d?.nom_entreprise) setEntreprise({ nom: d.nom_entreprise, logo: d.logo_url });
      }).catch(err => console.error('Erreur:', err));
  }, []);

  const user = authUser || {
    id: 1, username: 'admin', nom_complet: 'Administrateur',
    role: 'admin', boutique_id: workspaceContext?.boutique_id,
    boutique_nom: workspaceContext?.boutique_nom,
  };
  const isBoutique = contextType === 'boutique';
  const handleLogout = () => { if (authLogout) authLogout(); onChangeContext(); };
  const isActive = (path) => location.pathname === path;

  const MENUS = {
    boutique: [
      { section: 'Boutique' },
      { path: '/', label: 'Tableau de bord', icon: LayoutDashboard },
      { path: '/vente-boutique', label: 'Vente', icon: ShoppingBag },
      { path: '/caisse', label: 'Caisse', icon: Lock },
      { path: '/factures', label: 'Factures', icon: Receipt },
      { path: '/clients', label: 'Clients', icon: UserCircle },
      { path: '/ventes', label: 'Historique ventes', icon: ShoppingCart },
      { path: '/sav', label: 'SAV', icon: Wrench },
      { section: 'Stock' },
      { path: '/bijoux', label: 'Bijoux', icon: Gem },
      { path: '/depots', label: 'Depots', icon: PackageCheck },
      { path: '/stocks', label: 'Stocks', icon: Warehouse },
      { path: '/inventaire', label: 'Inventaire', icon: ClipboardList },
      { path: '/transferts', label: 'Transferts', icon: ArrowLeftRight },
      { path: '/tracabilite', label: 'Tracabilite', icon: History },
    ],
    atelier: [
      { section: 'Production' },
      { path: '/', label: 'Tableau de bord', icon: LayoutDashboard },
      { path: '/pilotage-production', label: 'Pilotage production', icon: BarChart3 },
      { path: '/devis', label: 'Devis', icon: FileText },
      { path: '/atelier', label: 'Ordres de fabrication', icon: Wrench },
      { path: '/ouvriers', label: 'Ouvriers', icon: Users },
      { path: '/atelier/stock-composants', label: 'Stock Composants', icon: Package },
      { path: '/stock-tracabilite', label: 'Suivi Or & Pierres', icon: Activity },
      { path: '/tracabilite-or', label: 'Tracabilite Or', icon: Scale },
      { section: 'Suivi' },
      { path: '/historique-taches', label: 'Historique taches', icon: History },
      { path: '/rapport-ordres-clotures', label: 'Rapport production', icon: FileText },
      { path: '/impression-etiquettes', label: 'Impression Étiquettes', icon: Printer },
      { path: '/tracabilite', label: 'Tracabilite', icon: History },
      { path: '/sav', label: 'SAV', icon: Wrench },
    ],
    chef_atelier: [
      { section: 'Production' },
      { path: '/', label: 'Tableau de bord', icon: LayoutDashboard },
      { path: '/atelier', label: 'Ordres de fabrication', icon: Wrench },
      { path: '/ouvriers', label: 'Ouvriers', icon: Users },
      { section: 'Suivi' },
      { path: '/historique-taches', label: 'Historique taches', icon: History },
      { path: '/impression-etiquettes', label: 'Impression Étiquettes', icon: Printer },
    ],
    ouvrier: [
      { section: 'Mes tâches' },
      { path: '/mes-taches', label: 'Mes tâches', icon: Wrench },
    ],
    central: [
      { section: 'Vue globale' },
      { path: '/', label: 'Tableau de bord', icon: LayoutDashboard },
      { path: '/rapport-financier', label: 'Rapport financier', icon: FileText },
      { path: '/rapport-boutiques', label: 'Rapport boutiques', icon: BarChart3 },
      { path: '/rapport-bijoux', label: 'Rapport bijoux', icon: Gem },
      { path: '/rapport-ouvriers', label: 'Rapport ouvriers', icon: Users },
      { section: 'Commercial' },
      { path: '/devis', label: 'Devis', icon: FileText },
      { path: '/vente-boutique', label: 'Vente', icon: ShoppingBag },
      { path: '/factures', label: 'Factures', icon: Receipt },
      { path: '/caisse', label: 'Caisse', icon: Lock },
      { path: '/caisse-generale', label: 'Caisse generale', icon: DollarSign },
      { path: '/ventes', label: 'Historique ventes', icon: ShoppingCart },
      { path: '/clients', label: 'Clients', icon: UserCircle },
      { path: '/promotions', label: 'Promotions', icon: Tag },
      { path: '/sav', label: 'SAV', icon: Wrench },
      { section: 'Production' },
      { path: '/pilotage-production', label: 'Pilotage production', icon: BarChart3 },
      { path: '/atelier', label: 'Ordres de fabrication', icon: Wrench },
      { path: '/ouvriers', label: 'Ouvriers', icon: Users },
      { path: '/rapport-ordres-clotures', label: 'Rapport production', icon: FileText },
      { path: '/impression-etiquettes', label: 'Impression Étiquettes', icon: Printer },
      { path: '/tracabilite-or', label: 'Tracabilite Or', icon: Scale },
      { section: 'Stock & Logistique' },
      { path: '/bijoux', label: 'Bijoux', icon: Gem },
      { path: '/catalogue-bijoux', label: 'Catalogue bijoux', icon: Grid },
      { path: '/stocks', label: 'Stocks', icon: Warehouse },
      { path: '/inventaire', label: 'Inventaire', icon: ClipboardList },
      { path: '/transferts', label: 'Transferts', icon: ArrowLeftRight },
      { path: '/depots', label: 'Achat & Dépôts', icon: PackageCheck },
      { path: '/tracabilite', label: 'Tracabilite', icon: History },
      { path: '/stock-tracabilite', label: 'Suivi Or & Pierres', icon: Activity },
      { path: '/gestion-couts', label: 'Gestion coûts', icon: DollarSign },
      { section: 'Achats' },
      { path: '/fournisseurs', label: 'Fournisseurs', icon: Truck },
      { path: '/achats', label: 'Achats', icon: ShoppingBag },
      { path: '/paiements-fournisseurs', label: 'Paiements', icon: CreditCard },
      { path: '/depenses', label: 'Depenses & Charges', icon: DollarSign },
      { section: 'Admin' },
      { path: '/boutiques', label: 'Boutiques', icon: Store },
      { path: '/users', label: 'Utilisateurs', icon: Users },
      { path: '/admin/parametres', label: 'Ma bijouterie', icon: Settings },
      { path: '/admin/composants', label: 'Composants', icon: Box },
      { path: '/admin/categories-types', label: 'Categories', icon: Grid },
      { path: '/admin/audit', label: 'Journal actions', icon: Activity },
      { path: '/admin/backup', label: 'Sauvegardes', icon: Database },
      { path: '/admin/health', label: 'Monitoring système', icon: Shield },
      { path: '/admin/systeme', label: 'Etat systeme', icon: Activity },
    ],
  };

  // Chef atelier (role atelier/chef_atelier non-admin) → menu réduit
  const isChefAtelier = !isAdmin() && (user?.role === 'atelier' || user?.role === 'chef_atelier') && contextType === 'atelier';
  const menuKey = isChefAtelier ? 'chef_atelier' : contextType;
  const menuItems = MENUS[menuKey] || MENUS.central;

  const ALLOWED_ROUTES = {
    boutique:      ['/', '/vente-boutique', '/clients', '/ventes', '/bijoux', '/stocks', '/transferts', '/tracabilite', '/catalogue-stock', '/services', '/sav', '/caisse', '/factures', '/inventaire', '/depots'],
    atelier:       ['/', '/pilotage-production', '/devis', '/atelier', '/ouvriers', '/bijoux', '/historique-taches', '/rapport-ordres-clotures', '/tracabilite', '/suivi-fabrication', '/services', '/sav', '/atelier/stock-composants', '/stocks', '/achats-matieres', '/stock-tracabilite', '/impression-etiquettes', '/tracabilite-or'],
    // chef_atelier : PAS de bijoux, PAS de tracabilite, PAS de devis complets, PAS de coûts
    chef_atelier:  ['/', '/atelier', '/ouvriers', '/historique-taches', '/impression-etiquettes'],
    ouvrier:       ['/mes-taches'],
    central:       null,
  };
  // Utiliser menuKey (qui tient compte de isChefAtelier) pour la protection des routes
  const allowed = ALLOWED_ROUTES[menuKey];
  const defaultRoute = contextType === 'ouvrier' ? '/mes-taches' : '/';
  if (allowed && !allowed.includes(location.pathname) && location.pathname !== '/login') {
    return <Navigate to={defaultRoute} replace />;
  }

  const ctxLabel = contextType === 'boutique' ? (workspaceContext?.boutique_nom || 'Boutique')
    : contextType === 'atelier' ? 'Atelier'
    : contextType === 'ouvrier' ? 'Espace Ouvrier'
    : 'Central';

  const sidebarContent = (isMobile) => (
    <>
      {/* Logo */}
      <div className="flex items-center gap-3 px-3 py-4 border-b" style={{ borderColor: '#1e1e28' }}>
        {entreprise.logo ? (
          <img src={getServerUrl(entreprise.logo)}
            alt="" className="h-8 w-8 rounded object-cover flex-shrink-0" />
        ) : (
          <div className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0"
            style={{ background: 'linear-gradient(135deg, #d4af37, #f5e6a3)' }}>
            <Gem className="h-4 w-4 text-gray-900" />
          </div>
        )}
        {(isMobile || !collapsed) && (
          <div className="min-w-0">
            <div className="text-xs font-light tracking-[0.1em] uppercase truncate" style={{ color: '#d4af37', fontFamily: "'Georgia', serif" }}>
              {entreprise.nom}
            </div>
            <div className="text-xs truncate" style={{ color: '#555' }}>{ctxLabel}</div>
          </div>
        )}
      </div>

      {/* Menu */}
      <nav className="flex-1 overflow-y-auto py-2 px-2">
        {menuItems.map((item, i) => {
          if (item.section) {
            return (isMobile || !collapsed) ? (
              <div key={`s-${i}`} className="mt-4 mb-1 px-2">
                <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: '#555' }}>{item.section}</span>
              </div>
            ) : <div key={`s-${i}`} className="mt-3 mb-1 mx-auto w-6 h-px" style={{ background: '#2a2a3a' }} />;
          }
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link key={item.path} to={item.path}
              onClick={() => isMobile && setMobileOpen(false)}
              className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg mb-0.5 transition-all ${!isMobile && collapsed ? 'justify-center' : ''}`}
              style={{
                background: active ? 'linear-gradient(135deg, #d4af37, #c49b30)' : 'transparent',
                color: active ? '#0a0a0a' : '#888',
                fontWeight: active ? 600 : 400,
              }}
              title={!isMobile && collapsed ? item.label : ''}>
              <Icon className="h-4 w-4 flex-shrink-0" />
              {(isMobile || !collapsed) && <span className="text-xs truncate">{item.label}</span>}
            </Link>
          );
        })}
      </nav>

      {/* Footer sidebar */}
      <div className="border-t px-2 py-3" style={{ borderColor: '#1e1e28' }}>
        {(isMobile || !collapsed) && (
          <div className="px-2 mb-2">
            <p className="text-xs truncate" style={{ color: '#888' }}>{user?.nom_complet}</p>
          </div>
        )}
        <div className={`flex flex-col gap-1`}>
          {user?.role === 'admin' && (
            <button onClick={() => { if (isMobile) setMobileOpen(false); onChangeContext(); }} title="Changer de contexte"
              className="flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors w-full"
              style={{ background: '#1a1a24', color: '#aaa', border: '1px solid #2a2a3a' }}>
              <ArrowLeftRight className="h-3.5 w-3.5 flex-shrink-0" />
              {(isMobile || !collapsed) && <span>Changer d'espace</span>}
            </button>
          )}
          <button onClick={() => { if (isMobile) setMobileOpen(false); handleLogout(); }} title="Déconnexion"
            className="flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors w-full hover:opacity-80"
            style={{ background: '#2a1a1a', color: '#f87171', border: '1px solid #3a2a2a' }}>
            <LogOut className="h-3.5 w-3.5 flex-shrink-0" />
            {(isMobile || !collapsed) && <span>Déconnexion</span>}
          </button>
        </div>
        {!isMobile && (
          <button onClick={() => setCollapsed(!collapsed)}
            className="w-full mt-2 flex items-center justify-center py-1 rounded transition-colors"
            style={{ color: '#555' }}>
            {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
          </button>
        )}
      </div>
    </>
  );

  return (
    <div className="min-h-screen flex" style={{ background: '#f8f7f4' }}>

      {/* ── MOBILE TOP BAR ── */}
      <div className="fixed top-0 left-0 right-0 z-30 flex md:hidden items-center justify-between px-4 h-14"
        style={{ background: '#0f0f14', borderBottom: '1px solid #1e1e28' }}>
        <button onClick={() => setMobileOpen(true)} className="p-1.5 rounded-lg" style={{ color: '#d4af37' }}>
          <Menu className="h-6 w-6" />
        </button>
        <div className="flex items-center gap-2">
          {entreprise.logo ? (
            <img src={getServerUrl(entreprise.logo)} alt="" className="h-6 w-6 rounded object-cover" />
          ) : (
            <Gem className="h-5 w-5" style={{ color: '#d4af37' }} />
          )}
          <span className="text-sm font-light tracking-wider uppercase" style={{ color: '#d4af37', fontFamily: "'Georgia', serif" }}>
            {entreprise.nom}
          </span>
        </div>
        <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: '#1a1a24', border: '1px solid #2a2a3a' }}>
          <UserCircle className="h-5 w-5" style={{ color: '#888' }} />
        </div>
      </div>

      {/* ── MOBILE SIDEBAR OVERLAY ── */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setMobileOpen(false)} />
          {/* Sidebar panel */}
          <aside className="absolute top-0 left-0 h-full w-64 flex flex-col shadow-2xl"
            style={{ background: '#0f0f14', borderRight: '1px solid #1e1e28' }}>
            {sidebarContent(true)}
          </aside>
        </div>
      )}

      {/* ── DESKTOP SIDEBAR ── */}
      <aside className={`hidden md:flex fixed top-0 left-0 h-full z-40 transition-all duration-300 flex-col ${collapsed ? 'w-16' : 'w-56'}`}
        style={{ background: '#0f0f14', borderRight: '1px solid #1e1e28' }}>
        {sidebarContent(false)}
      </aside>

      {/* ── MAIN CONTENT ── */}
      <main className={`flex-1 transition-all duration-300 pt-14 md:pt-0 ${collapsed ? 'md:ml-16' : 'md:ml-56'}`}>
        <div className="max-w-7xl mx-auto px-4 py-4 md:px-6 md:py-6">
          {children}
        </div>
      </main>

      {/* ── NOTIFICATIONS GLOBALES ── */}
      <ErrorToast />
      <Toast />
    </div>
  );
}

export default Layout;
